<template>
    <div class="lang-switcher">
        <q-select
            v-model="langSelect"
            dark
            :options="locales"
            option-value="key"
            option-label="flag"
            map-options
            borderless
            @input="changeLocale(langSelect)"
        >
            <template v-slot:selected-item="scope">
                <img v-if="setFlag(scope.opt)" :src="setFlag(scope.opt)" />
                <span v-else>{{ scope.opt.key }}</span>
            </template>
            <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section>
                        <img
                            v-if="setFlag(scope.opt)"
                            :src="setFlag(scope.opt)"
                        />
                        <q-tooltip>
                            {{ scope.opt.name }}
                        </q-tooltip>
                    </q-item-section>
                </q-item>
            </template>
        </q-select>
    </div>
</template>

<script>
import userConfigurationsService from '@/services/modules/userConfigurations'
import store from '@/store'

const loadingKeys = {
    fetchingUserConfigurations: 'fetching-user-configurations',
    savingUserConfigurations: 'saving-user-configurations',
}

export default {
    name: 'LanguageSelector',

    data() {
        return {
            langSelect: '',
            i18Keys: '',
        }
    },

    computed: {
        locales() {
            return store.getters['locale/localeList']
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        userLogged() {
            return store.getters['session/user']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },

        isAuthenticated() {
            return store.getters['session/isAuthenticated']
        },
    },

    watch: {
        locale(value) {
            this.langSelect = value
        },
    },

    mounted() {
        this.langSelect = this.locale
        store.commit('locale/setLocale', this.locale)
    },

    methods: {
        changeLocale(locale) {
            this.langSelect = locale
            store.commit('locale/changeLocale', locale.key)
            // if (this.isAuthenticated) {
            //     let parameters = {
            //         token: this.userLogged.token,
            //         configurations: [
            //             {
            //                 locale: locale.key,
            //                 currency: this.currency.id,
            //             },
            //         ],
            //     }
            //     this.updateUserConfiguration(parameters)
            // }

            // update quasar componentes language
            let lang = 'pt'
            switch (this.langSelect.key) {
                case 'pt-AO':
                    lang = 'pt'
                    break
                case 'en-GB':
                    lang = 'en-gb'
                    break
                default:
                    lang = 'pt'
                    break
            }
            import('quasar/lang/' + lang).then((lang) => {
                this.$q.lang.set(lang.default)
            })
        },

        setFlag(lang) {
            let src = lang.key
                ? require('@/assets/images/flags/32/' +
                      lang.key.split('-')[1] +
                      '.png')
                : null
            return src ? src : null
        },

        async updateUserConfiguration(parameters) {
            this.loadingAdd(loadingKeys.savingUserConfigurations)

            let response = await userConfigurationsService.update(parameters)

            if (response.status !== 200) {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }
            this.loadingRemove(loadingKeys.savingUserConfigurations)
        },
    },
}
</script>
